// Traduzioni IT/EN per tutto il sito
const translations = {
  it: {
    nav: [
      { label: 'Home', href: '#home' },
      { label: 'Presentazione', href: '#about' },
      { label: 'Call for Artists', href: '#call' },
      { label: 'Programma', href: '#programma' },
      { label: 'Location', href: '#location' },
      { label: 'Partner', href: '#partner' },
      { label: 'About', href: '#about-bottom' },
      { label: 'Privacy Policy', href: '/privacy' },
    ],
    intro: {
      text: `Siamo pericolosamente, ostinatamente e indipendentemente giunti alla terza edizione di questa avventura. Il terzo avverbio è quello cui teniamo di più, quello che maggiormente caratterizza la natura di questa iniziativa.\n\nSenza santi in paradiso, mecenati o colpi di fortuna, ma con convinzione estrema e partecipazione incondizionata di artisti e designer, le prime due edizioni sono andate in porto. Piccole, intense e forse discrete, affascinanti quanto basta per convincerci a rilanciare e cercare qualcuno di quei santi, pronti a procedere con o senza di loro.\n\nQuindi ancora una settimana, due — o pure tre — di mostre, workshop ed eventi dedicati al rapporto tra design, industrie creative e sviluppo territoriale. Indipendenti, sempre.\n\nIl senso dell\'iniziativa \u00e8 duplice:`,
      claim1: "Indagare il contributo del design, dell'arte e delle industrie creative allo sviluppo delle aree interne",
      claim2: "Definire le aree interne come emittenti di cultura materiale contemporanea",
    },
    call: {
      sectionLabel: '',
      title: 'Call for Artists',
      status: '',
      extendedPlay: 'EXTENDED PLAY! Last days',
      extendedDeadline: 'Scadenza candidature: 11 luglio 2026 h 23:59',
      heroTitle: 'HEAVY WEATHER / INTEMPERIE',
      heroText: `Il cambiamento è in atto. Climatico, di conseguenza geopolitico, sociale, umano.\n\nIl primo, il cambiamento climatico, è da intendere non come fenomeno da impedire ma bestia da addomesticare. È in atto, in avanzamento rapido, è una condizione con cui avere a che fare. E, sia chiaro, è una manifestazione culturale, non un fenomeno naturale.\n\nQui si tratta di attrezzarsi. Talvolta di migrare e di attrezzarsi alla migrazione. Si tratta di concepire una generazione di merci ed opere, di attrezzi adeguati al cambiamento: tanto a resistere al suo interno, quanto a calmierarne lo sviluppo, magari assestandolo su un plateau non fatale, pur drammatico.\n\nL'arte non è un accessorio né un privilegio, è il tessuto simbolico che permette ad una società di riconoscersi, acquisire consapevolezza e proiettarsi nel futuro.`,
      subTitle: 'Opere come attivatori di cambiamento',
      subText: `Le opere d'arte come attivatori di risposte cognitive al cambiamento, di comportamenti, di visioni di un futuro più auspicabile.\n\nUn'opera può trasformare un dato in urgenza, un'immagine in coscienza, un'esperienza individuale in responsabilità collettiva.\n\nVersiamo in condizioni atmosferiche, geopolitiche e sociali estreme ma possiamo trasformare il passivo globale in motore di rigenerazione, a partire da una dimensione territoriale.\n\nPerché l'arte abita la conversazione democratica sul territorio, stimola la costruzione simbolica e affettiva del "comune". Una comunità senza arte è come una comunità senza conversazione collettiva, senza orizzonte comune.\n\nPartiamo con un atto di contemplazione militante.`,
      whoTitle: 'Chi cerchiamo',
      whoText: 'Rural Design Amiata cerca artisti, designer, architetti, artigiani, performer che vogliano rispondere alla sfida del cambiamento - non solo climatico - attraverso opere, progetti, interventi capaci di:',
      whoList: [
        'Interrogare il presente con sguardo critico',
        'Immaginare futuri possibili e desiderabili',
        'Attrezzare le comunità agli scenari che ci attendono',
        'Dialogare con il territorio del Monte Amiata e la sua storia mineraria',
      ],
      categoriesTitle: 'Opere ammesse',
      categoriesText: 'La call è aperta a proposte nelle seguenti discipline:',
      categoriesList: [
        'Architettura / Progettazione ambientale',
        'Land Art / Interventi site-specific',
        'Design industriale / di prodotto',
        'Fashion Design',
        'Arti visive (scultura, installazione, pittura)',
        'Grafica / Digital Media',
        'Artigianato (legno, ceramica, metallo, fibra...)',
        'Audiovisivo / Sound design',
        'Arti performative',
      ],
      whereText: 'Le opere saranno presentate/esposte presso gli spazi del Parco Nazionale delle Miniere del Monte Amiata all\'interno del programma di Rural Design Amiata.',
      btnRegolamento: 'Regolamento',
      btnPartecipa: 'Partecipa ora',
      formUrl: 'https://forms.gle/xD3KcYzvx4FXEiVs8',
      regolamentoTitle: 'Regolamento Call for Artists 2026',
    },
    marquee: [
      'Il respiro del design',
      'Il design respira',
      'Amiata Rural Design 2026',
    ],
    programma: {
      title: 'Programma',
      preliminary: 'Edizioni 2026 — Preliminare',
      sessions: [
        { label: 'RD26 + Mercurio (summer session)', date: '8–22 agosto' },
        { label: 'RD26 + Mercurio (autumn session)', date: '24–31 ottobre' },
      ],
      eventi: [
        { date: '09–18/08', title: 'Heavy Weather/Intemperie', type: 'Mostra distribuita di arte e design', location: 'Parco Museo delle Miniere - Abbadia San Salvatore' },
  	{ date: '09–18/08', title: 'Oggetti Migratori', type: 'Mostra Fashion Design', location: 'Parco Museo delle Miniere - Abbadia San Salvatore' },
  	{ date: '09/08', title: 'Mercurio Night', type: 'Inaugurazione', location: 'Parco Museo delle Miniere - Abbadia San Salvatore' },
  	{ date: 'Da riassegnare/08', title: 'Siele XP', type: 'Trekking, cena, installazioni', location: 'Miniera del Siele - Piancastagnaio' },
  	{ date: '14/08', title: 'RUDE Night', type: 'Performance musicali, installazioni video', location: 'Peschiera - Santa Fiora' },
  	{ date: '18/08', title: 'Mercurio, Minatori di altri mondi', type: 'Finissage Rural Design Amiata e rassegna', location: 'Parco Museo delle Miniere - Abbadia San Salvatore' },
      ],
    },
    location: {
      title: 'Location',
      mapsLabel: '↗ Apri in Google Maps',
      photos: [
        { caption: 'Spazio Espositivo - Villaggio Minerario, Abbadia San Salvatore' },
        { caption: 'Forni Miniera del Siele, Piancastagnaio' },
        { caption: 'Parco Museo delle Miniere, nicchie espositive, Abbadia San Salvatore' },
        { caption: 'Peschiera, Santa Fiora' },
        { caption: 'Parco Museo delle Miniere di Abbadia San Salvatore' },
        { caption: 'Monte Amiata' },
        { caption: 'Parco Museo delle Miniere, Essiccatoi, Abbadia San Salvatore' },
        { caption: 'Parco Museo delle Miniere di Abbadia San Salvatore' },
        { caption: 'Villaggio Minerario del Siele, Piancastagnaio' },
        { caption: 'Complesso di Sant"Antonio, Santa Fiora' },
      ],
    },
    partner: {
      title: 'Partner',
    },
    about: {
      title: 'About',
      text: '[EN About text — update in src/i18n.js]',
    },
    footer: {
      nav: 'Navigazione',
      partner: 'Partner',
      contact: 'Contatti',
      position: 'Posizione',
      privacy: 'Privacy & Cookie Policy',
      copyright: '© 2026 RUDE — Rural Design. Tutti i diritti riservati.',
      claim: 'Rural Design. Sempre indipendenti.',
    },
    cookie: {
      title: 'Questo sito usa cookie',
      text: 'Utilizziamo cookie tecnici e, con il tuo consenso, cookie analitici per migliorare la tua esperienza.',
      manageBtn: 'Gestisci preferenze',
      necessaryBtn: 'Solo necessari',
      acceptBtn: 'Accetta tutti',
      saveBtn: 'Salva preferenze',
      backBtn: 'Indietro',
      technicalTitle: 'Cookie tecnici',
      technicalDesc: 'Necessari al funzionamento del sito. Non disattivabili.',
      alwaysActive: 'Sempre attivi',
      analyticsTitle: 'Cookie analitici',
      analyticsDesc: 'Google Analytics 4 — dati anonimi sull\'utilizzo del sito.',
      manageTitle: 'Gestisci preferenze cookie',
    },
  },
  en: {
    nav: [
      { label: 'Home', href: '#home' },
      { label: 'Presentation', href: '#about' },
      { label: 'Call for Artists', href: '#call' },
      { label: 'Programme', href: '#programma' },
      { label: 'Location', href: '#location' },
      { label: 'Partners', href: '#partner' },
      { label: 'About', href: '#about-bottom' },
      { label: 'Privacy Policy', href: '/privacy' },
    ],
    intro: {
      text: `We have dangerously, stubbornly and independently reached the third edition of this adventure. The third adverb is the one we care about most — it best characterises the nature of this initiative.\n\nWithout patrons, benefactors or strokes of luck, but with extreme conviction and unconditional participation from artists and designers, the first two editions made it to port. Small, intense and perhaps discreet, fascinating enough to convince us to raise the stakes and seek some of those patrons — ready to proceed with or without them.\n\nSo, another week, two — or even three — of exhibitions, workshops and events dedicated to the relationship between design, creative industries and territorial development. Independent, always.\n\nThe initiative has a multiple nature:`,
      claim1: "Investigating the contribution of design, art and creative industries to the development of inner areas",
      claim2: "Defining inner areas as emitters of contemporary material culture",
    },
    call: {
      sectionLabel: '',
      title: 'Call for Artists',
      status: '',
      extendedPlay: 'EXTENDED PLAY! Last days',
      extendedDeadline: 'New deadline: July 11th h 23:59',
      heroTitle: 'HEAVY WEATHER / INTEMPERIE',
      heroText: `Change is underway. Climatic, and consequently geopolitical, social, human.\n\nThe first — climate change — is not to be understood as a phenomenon to prevent, but as a beast to tame. It is underway, advancing rapidly, a condition we must deal with. And let us be clear: it is a cultural manifestation, not a natural phenomenon.\n\nThe task here is to equip ourselves. Sometimes to migrate and to prepare for migration. It means conceiving a generation of goods and works, of tools adequate to change: both to resist within it, and to moderate its development — perhaps settling it on a plateau that, while dramatic, is not fatal.\n\nArt is not an accessory nor a privilege — it is the symbolic fabric that allows a society to recognise itself, gain awareness and project itself into the future.`,
      subTitle: 'Works as activators of change',
      subText: `Works of art as activators of cognitive responses to change, of behaviours, of visions of a more desirable future.\n\nA work can transform data into urgency, an image into consciousness, an individual experience into collective responsibility.\n\nWe are in extreme atmospheric, geopolitical and social conditions, but we can transform the global deficit into an engine of regeneration — starting from a territorial dimension.\n\nBecause art inhabits the democratic conversation on the territory, stimulates the symbolic and affective construction of the "commons". A community without art is like a community without collective conversation, without a shared horizon.\n\nLet us begin with an act of militant contemplation.`,
      whoTitle: 'Who we are looking for',
      whoText: 'Rural Design Amiata seeks artists, designers, architects, craftspeople and performers who want to respond to the challenge of change — not only climatic — through works, projects and interventions capable of:',
      whoList: [
        'Questioning the present with a critical eye',
        'Imagining possible and desirable futures',
        'Equipping communities for the scenarios ahead',
        'Engaging with the Monte Amiata territory and its mining history',
      ],
      categoriesTitle: 'Eligible categories',
      categoriesText: 'The call is open to proposals in the following disciplines:',
      categoriesList: [
        'Architecture / Environmental design',
        'Land Art / Site-specific interventions',
        'Industrial / product design',
        'Fashion design / Textile',
        'Visual arts (sculpture, installation, painting)',
        'Graphics / Digital media',
        'Crafts (wood, ceramics, metal, fibre)',
        'Audiovisual / Sound design',
        'Performing arts',
      ],
      whereText: 'Works will be presented and exhibited in the spaces of the Parco Nazionale delle Miniere del Monte Amiata as part of the Rural Design Amiata programme.',
      btnRegolamento: 'Guidelines',
      btnPartecipa: 'Apply now',
      formUrl: 'https://docs.google.com/forms/d/1FJ-Nqy9WEVEsxi-YzhiRXoleLhHoIS_WVPu2o9Z__9M/edit',
      regolamentoTitle: 'Call for Artists 2026 — Guidelines',
    },
    marquee: [
      'The breath of design',
      'Design breathes',
      'Amiata Rural Design 2026',
    ],
    programma: {
      title: 'Programme',
      preliminary: '2026 Editions — Preliminary',
      sessions: [
        { label: 'RD26 + Mercurio (summer session)', date: '8–22 August' },
        { label: 'RD26 + Mercurio (autumn session)', date: '24–31 October' },
      ],
      eventi: [
  	{ date: '09–18/08', title: 'Heavy Weather/Intemperie', type: 'Distributed art and design exhibition', location: 'Parco Museo delle Miniere - Abbadia San Salvatore' },
  	{ date: '09–18/08', title: 'Oggetti Migratori', type: 'Fashion Design Exhibition', location: 'Parco Museo delle Miniere - Abbadia San Salvatore' },
  	{ date: '09/08', title: 'Mercurio Night', type: 'Opening night', location: 'Parco Museo delle Miniere - Abbadia San Salvatore' },
  	{ date: 'TBD/08', title: 'Siele XP', type: 'Trekking, dinner, installations', location: 'Miniera del Siele - Piancastagnaio' },
  	{ date: '14/08', title: 'RUDE Night', type: 'Music performances, video installations', location: 'Peschiera - Santa Fiora' },
  	{ date: '18/08', title: 'Mercurio, Miners of other worlds', type: 'Rural Design Amiata finissage and exhibition', location: 'Parco Museo delle Miniere - Abbadia San Salvatore' },
      ],
    },
    location: {
      title: 'Location',
      mapsLabel: '↗ Open in Google Maps',
      photos: [
        { caption: 'Exhibition Space - Mining Village, Abbadia San Salvatore' },
        { caption: 'Siele Mine Furnaces, Piancastagnaio' },
        { caption: 'Mining Museum Park, exhibition niches, Abbadia San Salvatore' },
        { caption: 'Peschiera, Santa Fiora' },
        { caption: 'Mining Museum Park, Abbadia San Salvatore' },
        { caption: 'Monte Amiata' },
        { caption: 'Mining Museum Park, Drying rooms, Abbadia San Salvatore' },
        { caption: 'Mining Museum Park, Abbadia San Salvatore' },
        { caption: 'Mining Village of Siele, Piancastagnaio' },
        { caption: 'Sant"Antonio Complex, Santa Fiora' },
      ],
    },
    partner: {
      title: 'Partners',
    },
    about: {
      title: 'About',
      text: `This project began in 2021, when we conceived and developed Monte Amiata's candidacy for Italian Capital of Culture. The process wasn't recognized—it's a surprisingly opaque process, after all—but it established a system of visions capable of contributing to the development of this area, as well as the inland regions more generally. From that dossier, we drew hypotheses, dreams, and project elements. And we continue to draw, with conviction and a visionary approach. A diverse and flexible working group, composed of figures from institutions, private individuals, and associations, united by a love of culture, methodological expertise, and a visceral connection with the territories of this, still our favorite planet.`,
    },
    footer: {
      nav: 'Navigation',
      partner: 'Partners',
      contact: 'Contact',
      position: 'Location',
      privacy: 'Privacy & Cookie Policy',
      copyright: '© 2026 RUDE — Rural Design. All rights reserved.',
      claim: 'Rural Design. Always independent.',
    },
    cookie: {
      title: 'This site uses cookies',
      text: 'We use technical cookies and, with your consent, analytics cookies to improve your experience.',
      manageBtn: 'Manage preferences',
      necessaryBtn: 'Necessary only',
      acceptBtn: 'Accept all',
      saveBtn: 'Save preferences',
      backBtn: 'Back',
      technicalTitle: 'Technical cookies',
      technicalDesc: 'Required for the site to function. Cannot be disabled.',
      alwaysActive: 'Always active',
      analyticsTitle: 'Analytics cookies',
      analyticsDesc: 'Google Analytics 4 — anonymous data on site usage.',
      manageTitle: 'Manage cookie preferences',
    },
  },
};

export default translations;
